module.exports = __webpack_public_path__ + "img/teams-football@2x.800c7f31.jpg";